import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCapsuleIo } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_IO: TIdToPageConfigMap = {
  [PageIdStylioCapsuleIo.AGE_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.AGE_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioCapsuleIo.URGE_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.URGE_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsuleIo.HAIR_COLOR_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.HAIR_COLOR_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.EYES_COLOR_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.EYES_COLOR_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.JEWELRY_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.JEWELRY_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.BODY_SHAPE_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.BODY_SHAPE_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.OUTFIT_STRUGGLES_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.OUTFIT_STRUGGLES_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.STYLIO_TO_HELP_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.STYLIO_TO_HELP_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.TALL_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.TALL_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.WEIGHT_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.WEIGHT_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.BODY_COMFORT_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.BODY_COMFORT_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.WHAT_YOU_WEAR_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.WHAT_YOU_WEAR_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsuleIo.URGE_2_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.URGE_2_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsuleIo.FEEL_ABOUT_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.FEEL_ABOUT_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.WARDROBE_USAGE_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.WARDROBE_USAGE_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.NOT_ALONE_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.NOT_ALONE_CAPSULE_IO,
    headerId: HeaderId.BACK_TITLE_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdStylioCapsuleIo.PERCENTAGE_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.PERCENTAGE_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.SHOPPING_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.SHOPPING_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.STYLE_MOST_MATTERS_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.STYLE_MOST_MATTERS_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.YOUR_LOCATION_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.YOUR_LOCATION_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.FAVORITE_COLORS_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.FAVORITE_COLORS_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_11_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_11_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_12_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_12_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_13_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_13_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_14_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_14_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_15_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_15_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_16_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_16_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_17_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_17_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_18_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_18_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_19_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_19_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.SEE_YOURSELF_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.SEE_YOURSELF_CAPSULE_IO,
    headerId: HeaderId.BACK_TITLE_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdStylioCapsuleIo.STYLES_FEEL_LIKE_YOU_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.STYLES_FEEL_LIKE_YOU_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.URGE_4_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.URGE_4_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsuleIo.WHAT_YOU_WILL_FIND_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.WHAT_YOU_WILL_FIND_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsuleIo.BRAND_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.BRAND_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.FIND_NEW_CLOTHES_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.FIND_NEW_CLOTHES_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.NOTHING_TO_WEAR_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.NOTHING_TO_WEAR_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.OLD_CLOTHES_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.OLD_CLOTHES_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.COMBINE_CLOTHES_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.COMBINE_CLOTHES_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.OPTIMIZE_BUDGET_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.OPTIMIZE_BUDGET_CAPSULE_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsuleIo.URGE_3_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.URGE_3_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsuleIo.PREPARE_FLOW_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.PREPARE_FLOW_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsuleIo.EMAIL_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.EMAIL_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsuleIo.EMAIL_CONSENT_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.EMAIL_CONSENT_CAPSULE_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsuleIo.SUBSCRIPTIONS_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.SUBSCRIPTIONS_CAPSULE_IO,
  },
  [PageIdStylioCapsuleIo.CANCEL_OFFER_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.CANCEL_OFFER_CAPSULE_IO,
  },
  [PageIdStylioCapsuleIo.AI_STYLIST_UPSELL_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.AI_STYLIST_UPSELL_CAPSULE_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsuleIo.SUB_UPSELL_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.SUB_UPSELL_CAPSULE_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsuleIo.UPSELL_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.UPSELL_CAPSULE_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsuleIo.FACE_UPSELL_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.FACE_UPSELL_CAPSULE_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsuleIo.BUNDLE_UPSELL_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.BUNDLE_UPSELL_CAPSULE_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsuleIo.DOWNLOAD_CAPSULE_IO]: {
    id: PageIdStylioCapsuleIo.DOWNLOAD_CAPSULE_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
